import { Trash } from '@otp/icons';
import {
  DeleteMostScheduledJobDocument,
  MostScheduledJobsDocument,
} from 'src/graphql/generated/graphql';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { PartialMostScheduledJobListType } from 'src/components/most/list/scheduled-jobs/types';
import { DeleteConfirmation } from 'src/components/common/form/delete-confirmation';

type DeleteActionProps = {
  mostScheduledJob: PartialMostScheduledJobListType;
};

const QUERIES_TO_REFETCH = [MostScheduledJobsDocument];

export const DeleteAction = ({ mostScheduledJob }: DeleteActionProps) => {
  const [deleteMutation] = useMutation(DeleteMostScheduledJobDocument, {
    refetchQueries: QUERIES_TO_REFETCH,
  });

  const { t } = useTranslation(undefined, {
    keyPrefix: 'most.list.scheduled-jobs',
  });

  const [isDeleting, setIsDeleting] = useState(false);

  const onDelete = () => {
    deleteMutation({
      variables: {
        id: mostScheduledJob.id,
      },
    });
    setIsDeleting(false);
  };

  return (
    <>
      <Trash onClick={() => setIsDeleting(true)} />
      {isDeleting && (
        <DeleteConfirmation
          objectTitle={mostScheduledJob?.jobConfig?.name || ''}
          objectType={t('scheduled-jobs')}
          open={isDeleting}
          onClose={() => setIsDeleting(false)}
          onConfirm={onDelete}
        />
      )}
    </>
  );
};
